import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({ selector: 'form[appScrollToError]' })
export class ScrollToErrorDirective {
  constructor(private el: ElementRef<HTMLFormElement>) {}

  @HostListener('ngSubmit')
  onSubmit() {
    if (!this.el.nativeElement.classList.contains('ng-invalid')) {
      return;
    }
    setTimeout(() => {
      const firstInvalid = this.el.nativeElement.querySelector<HTMLElement>(
        'input.ng-invalid, select.ng-invalid, textarea.ng-invalid'
      );
      firstInvalid?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
}
